import c3 from 'c3';
import 'c3/c3.min.css';
import * as d3 from 'd3';
// import D3Funnel from 'd3-funnel/dist/d3-funnel.js';
import "./styles.css";
import useStyles from "./styles";
import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { pathOr } from "ramda";
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../Skeleton/index";
import { useSelector } from "react-redux";

const CustomDashletChartXirr = ({ data, fullData, value, result = [], showXirrVersion,isDashletUpdated=[],allTabFilter=[] }) => {
const { storeStateData,storeStateLoading } = useSelector((state) => state.dashboard);
 
	const { currentTheme } = useSelector((state) => state.config.themeConfig);
	const [policy, setPolicy] = useState(pathOr(false, [pathOr('', ['filter',1], data),pathOr('', ['filter',2], data)], allTabFilter));

	const [xirrDataYearly, setXirrDataYearly] = useState(pathOr(pathOr(pathOr(pathOr([], ['sameResponseTo', 'data', 'overall', 'yearly'], fullData), ['sameResponseTo', 'data', policy, 'yearly'], fullData), [ 'xirr','data','RP','overall','yearly'], storeStateData), [ 'xirr','data','SP','overall','yearly'], storeStateData));
	const [xirrDataCagr, setXirrDataCagr] = useState(pathOr(pathOr(pathOr(pathOr([], ['sameResponseTo', 'data', 'overall', 'cagr'], fullData), ['sameResponseTo', 'data', policy, 'cagr'], fullData), [ 'xirr','data','RP','overall','cagr'], storeStateData), [ 'xirr','data','SP','overall','cagr'], storeStateData));
	const [dashId, setDashId] = useState(pathOr('', ['id'], fullData));
	const [policyTypeName, setPolicyType] = useState(pathOr('',['sameResponseTo', 'data'], fullData)?Object.keys(pathOr({'SP':'SP'},['sameResponseTo', 'data'], fullData))[0]: 'SP');

	const [showLoading,setShowLoading]= useState(isDashletUpdated.includes(dashId));
	const {  configureDashletLoading } = useSelector(
		(state) => state.dashboard,
	  );
	const updateXirrData = (year, cagr) => {
		setXirrDataYearly(
			pathOr(
				pathOr(
					pathOr(
						pathOr(
							pathOr(
								pathOr(
									[], 
									['sameResponseTo', 'data','RP', 'overall', year], fullData
								), 
								['sameResponseTo', 'data','SP', 'overall', year], fullData
							),
							['sameResponseTo', 'data', 'overall', year], fullData
						), 
						['sameResponseTo', 'data', policy, year], fullData
					), 
				[ 'xirr','data','RP','overall',year], storeStateData
			), 
		[ 'xirr','data','SP','overall',year], storeStateData
		));

		setXirrDataCagr(
			pathOr(
				pathOr(
					pathOr(
						pathOr(
							pathOr(
								pathOr(
									[], 
									['sameResponseTo', 'data','RP', 'overall', cagr], fullData
								), 
								['sameResponseTo', 'data','SP', 'overall', cagr], fullData
							), 
							['sameResponseTo', 'data', 'overall', cagr], fullData
						), 
						['sameResponseTo', 'data', policy, cagr], fullData
					), 
					[ 'xirr','data','RP','overall',cagr], storeStateData
				), 
				[ 'xirr','data','SP','overall',cagr], storeStateData
			));
		
		setPolicyType(showXirrVersion !== 'overall' ? showXirrVersion : pathOr('',['sameResponseTo', 'data'], fullData)?Object.keys(pathOr({'SP':'SP'},['sameResponseTo', 'data'], fullData))[0]: 'SP');
	}
	//   console.log("chartttttttttttttt",policy,allTabFilter,fullData)
	useEffect(()=>{
		setPolicy(pathOr(false, [pathOr('', ['filter',1], data),pathOr('', ['filter',2], data)], allTabFilter));
	}, [allTabFilter])
	
	  useEffect(() => {
		updateXirrData("yearly", "cagr");
	}, [storeStateData])	  
	
	useEffect(() => {
		//Changes in state was not loading properly
		updateXirrData("yearly", "cagr");
	  }, [policy, fullData]);

	const classes = useStyles();
	let chartJson = [];
	const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
	let chartNewName = Math.random();
	let chartName = data.name;
	  
	switch (data.type) {
		case 'xirr':
		case 'policy_summary':
			//Console log removal
			const policyType = { SP: 'Single Premium', RP: 'Regular Premium', overall: 'Consolidated Total' };
			const yearData = Object.values(xirrDataYearly).map((DateValue) => DateValue === 'NA' ? 0 : getCalculations('convertIntoPercentWithoutSign', DateValue));
			const yearly = [ 'Yearly Return', ...yearData ];

			const cagrData = Object.values(xirrDataCagr).map((DateValue) => DateValue === 'NA' ? 0 : getCalculations('convertIntoPercentWithoutSign', DateValue));
			const cagr = [ 'Ave. Annual Return', ...cagrData ];
			// console.log(cagr);
			const currYear = new Date().getFullYear();
			let yearKeyValue = [];
			let yearkey = Object.keys(xirrDataYearly);
			for(let i=yearkey.length-1; i>=0; i--){
				if(policy)
					yearKeyValue[yearkey.length-i-1] = yearkey.length-i;
				else	
					yearKeyValue[i] =  currYear - (yearkey.length-i-1);
			}

			// const yearKeyValue = Object.keys(xirrDataYearly).map((DateValue) => DateValue);
			const xAxisLableValue = [ 'x', ...yearKeyValue ]; // x-axis values
// console.log("showXirr",showXirrVersion)
			// const chartTitle = policy?'Historical Returns of Policy '+ policy:'Historical Returns of Your '+policyType[showXirrVersion]+' Portfolio'; // Chart Title
			const chartTitle = policy?'Historical Returns of Policy '+ policy:'Historical Returns of Your '+policyType[policyTypeName]+' Portfolio'; // Chart Title

			//Calculate Ratio of chart
			let ratio = 0.1;
			if(yearkey.length <= 2){
				ratio = 0.05;
			}else if(yearkey.length > 2 && yearkey.length <=5){
				ratio = 0.15;
			}else if(yearkey.length >=5 && yearkey.length < 8){
				ratio = 0.3;
			}else if(yearkey.length >=8 && yearkey.length < 12){
				ratio = 0.4;
			}else if(yearkey.length >=12){
				ratio = 0.5;
			}

			chartJson = {
				padding: {
					right: 20,
					bottom: 20,
				},
				bindto: '#' + chartName,
				data: {
					x: 'x',
					columns: [
						xAxisLableValue, yearly, cagr
					],
					axes: {
						'Yearly Return': 'y',
						'Ave. Annual Return': 'y2'
					},
					type: 'bar',
					types: {
						// 'Ave. Annual Return': 'spline',
						'Ave. Annual Return': 'line',
						// 	'Percentage': 'area',
					},

					// groups: [
					// 	['data1','data2']
					// ],
					empty: { label: { text: "Loading..." } },

				},
				// zoom: {
				// 	enabled: true,
				// 	type: 'scroll', //default
				// 	rescale: false,
				// },
				title: {
					text: chartTitle,
				},
				padding: {
					right: 80
				},				  
				subchart: {
					show: true
				},
				grid: {
					y: {
						lines: [{ value: 0 }]
					}
				},
				bar: {
					width: {
						ratio: ratio // this makes bar width 50% of length between ticks
					}
				}, axis: {
					x: {
						
						extent: [2, 4],
						type: 'category',
						tick: {
							rotate: 30,
							multiline: false,
						},
						// height: 130
					},
					y2: {
						show: true,
						tick: {
							format: function (d) {
								return (parseInt(d) == d) ? d.toFixed(2)+'%' : d.toFixed(2)+'%';
							}
						},
						label: {
							text: 'Year on Year Return',
							position: 'outer-middle'
						}
					},
					range: { max: 100, min: -100 },
					y: {
						label: {
							text: 'Average Annual Return',
							position: 'outer-middle'
							// inner-right : default
							// inner-center
							// inner-left
							// outer-right
							// outer-center
							// outer-left
						},
						tick: {
							format: function (d) {
								return (parseInt(d) == d) ? d.toFixed(2)+'%' : d.toFixed(2)+'%';
							}
						}
					}
				}


			};
			break;
		default:
			chartJson = {};

	}

	React.useEffect(() => {
				 c3.generate(chartJson);
		}, [chartJson]);
	return (
		<div className={currentTheme === 'dark' ? "inverted" : null}>

			{
				 (configureDashletLoading && !isDashletUpdated.length) || (showLoading) || (storeStateLoading) ? <SkeletonShell layout={data.type==='pie'?"chartRound":"chartRectangle"} /> : <div key={chartName} style={{height:360}} className={classes.chartBox} id={chartName}>
					<Typography align="center"><i className={" fas fa-7x fa-exclamation-triangle " + classes.noData}></i></Typography>
					<Typography align="center" color="textSecondary">No Data</Typography>
				</div>}
		</div>
	);

}
export default React.memo(CustomDashletChartXirr);